import { useMutation as T } from "@tanstack/react-query";
import { setupAuth as h } from "../listener.es.js";
import { verifyOTPMutation as k } from "../reactQuery.es.js";
import { updateAuthState as d } from "../store.es.js";
const A = ({ onRedirect: n, ...t }) => T(
  k({
    ...t,
    onMutate: (...i) => {
      d({ status: "loading" }), t != null && t.onMutate && t.onMutate(...i);
    },
    onSuccess: (i, e, o) => {
      var r;
      if (d({ status: "initialized" }), !(i != null && i.success)) return;
      const u = (r = i.data) == null ? void 0 : r.data;
      if (u) {
        if (e.clientId) {
          "redirect_uri" in u && u.redirect_uri && n(u.redirect_uri);
          return;
        }
        if ("authToken" in u && u.authToken) {
          const { authToken: c, refreshToken: m } = u || {};
          if (!c) return;
          const f = e.redirectUrl, l = () => {
            var a;
            (a = e.onCompleted) == null || a.call(e), f && n(f);
          };
          h({ ...e, accessToken: c, refreshToken: m }, l);
        }
        t != null && t.onSuccess && t.onSuccess(i, e, o);
      }
    }
  })
);
export {
  A as useVerifyOTP
};
